import React from 'react';
import DashboardStub from 'components/kea/DashboardStub';
import IntlMessages from 'util/IntlMessages';

const PlaceholderError = ({ height = 250, error }) => {
  if (error === 'NO_DATA') {
    return <DashboardStub variant="table" height={Math.min(height, 360)} />;
  }

  return (
    <div className="loader-view placeholder-error">
      <img
        src={require('assets/images/placeholder/server-is-no-available-1.svg')}
        alt={error}
      />
      <br />
      <h1><IntlMessages id="ui.kea.placeholders.placeholderError.sorrySomethingWentWrong" /></h1>
    </div>
  );
};
export default PlaceholderError;
